<div class="race-by-bib">
    <ion-row [ngClass]="{'timer': !timerStarted,'timer-blue': timerStarted}" (click)="recordAthTime()">
        <ion-col text-center style="padding-top: 0;">
            <strong [style.color]="color">
                <p class="font-size-verylarge">{{displayTimer()}}</p>
            </strong>
            <p *ngIf="timerStarted">Click to record time</p>
        </ion-col>
    </ion-row>
    <ion-row class="track-buttons-container">
        <div class="track-buttons">
            <ion-col>
                <button ion-button icon-only clear (click)="openScoreBoardBib()">
                    <ion-icon name="list"></ion-icon>
                </button>
            </ion-col>
            <ion-col>
                <button *ngIf="!timerStarted"[style.backgroundColor]="color" ion-button icon-only clear (click)="startTimer()">
                    <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle"></ion-icon>
                </button>
                <button *ngIf="timerStarted"[style.backgroundColor]="color" ion-button class="round scale-big colored round-big" icon-only clear (click)="pauseTimer()">
                    <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                </button>
            </ion-col>
            <ion-col>
                <button ion-button icon-only clear (click)="restartTimer()">
                    <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline"></ion-icon>
                </button>
            </ion-col>
        </div>
    </ion-row>
<ion-row class="athletes">
<ion-row class="scoreboard-header">
    <ion-col class="scoreboard-header-place">Place</ion-col>
    <ion-col class="scoreboard-header-bibNumber">Bib</ion-col>
    <ion-col class="scoreboard-header-name">Name</ion-col>
    <ion-col class="scoreboard-header-time">Time</ion-col>
</ion-row>
<div class="athletes-container" #scrollMe [scrollTop]="scrollMe.scrollHeight">
    <ion-row class="athletes">
        <div class="athlete" *ngFor="let athlete of athletes" (click)="enterBibNumber(athlete)">
            <p class="athlete-place">{{athlete.place}}</p> <p [ngClass]="{'athlete-bibNo-grey': athlete.isSelected, 
                                                       'athlete-bibNo-white': !athlete.isSelected}">{{athlete.bibNo}}</p> <p class="athlete-name">{{athlete.name}}</p> <p><span class="athlete-time">{{athlete.time}}</span></p>
        </div>
    </ion-row>
</div>
</ion-row>
<ion-row class="bottom-numpud-container">
    <div class="bottom-numpud">
        <button ion-button (click)="enterNumber(1)">1</button>
        <button ion-button (click)="enterNumber(2)">2</button>
        <button ion-button (click)="enterNumber(3)">3</button>
        <button ion-button (click)="enterNumber(4)">4</button>
        <button ion-button (click)="enterNumber(5)">5</button>
        <button ion-button (click)="enterNumber(6)">6</button>
        <button ion-button (click)="enterNumber(7)">7</button>
        <button ion-button (click)="enterNumber(8)">8</button>
        <button ion-button (click)="enterNumber(9)">9</button>
        <button ion-button (click)="deleteBibNumber()"><ion-icon name="backspace"></ion-icon></button>
        <button ion-button (click)="enterNumber(0)">0</button>
        <button ion-button (click)="enterNumPud()">Enter</button>
    </div>
</ion-row>
</div>
    